import { create } from 'zustand';

const useRemixInfoModalStore = create((set) => ({
  // State
  isOpen: false,

  // Actions
  openModal: () => set({ isOpen: true }),
  closeModal: () => set({ isOpen: false }),
  toggleModal: () => set((state) => ({ isOpen: !state.isOpen })),
}));

export default useRemixInfoModalStore;
